module.exports = __webpack_public_path__ + "static/media/invest_in_mf_banner.d363827c.svg";